/**
 * Initializes and manages the Algolia Search Insights client instance
 * Provides client lifecycle management and status tracking
 */

import { AlgoliaConfigResolver } from './AlgoliaConfigResolver';

// Use global window.aa instead of importing
declare global {
  interface Window {
    aa: any;
  }
}

export class AlgoliaClientManager {
  private algoliaInsightsClient: any | null = null;
  private isInitialized: boolean = false;
  private configResolver: AlgoliaConfigResolver;

  constructor(configResolver: AlgoliaConfigResolver) {
    this.configResolver = configResolver;
  }

  /**
   * Creates and configures the Algolia Insights client with app credentials
   * @returns True if initialization was successful
   */
  public initializeInsightsClient(): boolean {
    const constants = this.configResolver.getConstants();

    // Use the global window.aa that was initialized by algolia-header-init.php
    if (typeof window.aa === 'function' || (typeof window.aa === 'object' && window.aa !== null)) {
      this.algoliaInsightsClient = window.aa;

      this.isInitialized = true;
      return true;
    } else {
      console.warn('[AlgoliaClientManager] window.aa not available');
      return false;
    }
  }

  /**
   * Provides access to the configured client instance for event tracking
   * @returns The Algolia Insights client or null if not initialized
   */
  public getInsightsClient(): any | null {
    return this.algoliaInsightsClient;
  }

  /**
   * Validates that client is properly initialized and available for use
   * @returns True if client is ready for use
   */
  public isReady(): boolean {
    return this.isInitialized && this.algoliaInsightsClient !== null;
  }

}